<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import request from '@/utils/request'

  export default {
    created: function() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this

      // check if the token has expired
      request.interceptors.response.use(undefined, function(err) {
        return new Promise(() => {
          if (err.response !== undefined && err.response.status === 401 && err.response.config && !err.response.config.__isRetryRequest !== undefined) {
            vm.$store.dispatch('Auth/logout').then(() => {
              if (vm.$router.currentRoute.path !== '/login') {
                vm.$router.push('/login')
              }
            })
          }
          throw err
        })
      })
    }
  }
</script>
